import { ActiveAntsWarehouseCheckInService } from "src/services";
import { WarehouseCheckInFileType } from "src/enums";
import { useFileDownload } from "../useFileDownload";

type DownloadParams = {
  type: WarehouseCheckInFileType.GOODS_IN_EXPORTS;
  exportFileId: string;
};

export const useActiveAntsWarehouseCheckInFileDownload = (
  activeAntsWarehouseCheckInService: ActiveAntsWarehouseCheckInService
) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: FileLoadError,
    reset: resetDownload,
    retry: retryDownload
  } = useFileDownload<File>();

  const downloadFile = (params: DownloadParams) => {
    switch (params.type) {
      case WarehouseCheckInFileType.GOODS_IN_EXPORTS:
        return download({
          getFileData: () => activeAntsWarehouseCheckInService.getGoodsInExportUrl(params.exportFileId)
        });
    }
  };

  return {
    downloadFile,
    isFileDownloading,
    FileLoadError,
    resetDownload,
    retryDownload
  };
};
